/**
 * AES+RSA加解密工具类
 */
import CryptoJS from 'crypto-js'
import JSEncrypt from 'encryptlong'

/** 随机生成固定位数或者一定范围内的字符串数字组合
 * @param {Number} min 范围最小值
 * @param {Number} max 范围最大值，当不传递时表示生成指定位数的组合
 * @param {String} charStr指定的字符串中生成组合
 * @returns {String} 返回字符串结果
 * */
const randomRange = (min, max, charStr) => {
  var returnStr = "",
    range;
  if (typeof min == 'undefined') {
    min = 16;
  }
  if (typeof max == 'string') {
    charStr = max;
  }
  range = ((max && typeof max == 'number') ? Math.round(Math.random() * (max - min)) + min : min);
  charStr = charStr || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < range; i++) {
    var index = Math.round(Math.random() * (charStr.length - 1));
    returnStr += charStr.substring(index, index + 1);
  }
  return returnStr;
}
const ReqIv = randomRange()
// const ReqIv = 'DYgjCEIMVrj2W9xN'
const iv = CryptoJS.enc.Utf8.parse(ReqIv) //十六位十六进制数作为密钥偏移量
/**
 * AES加密
 *
 * @param word 加密内容
 * @param keyStr 十六位的十六进制数作为 加解密的密钥，一般是动态生成//abcdefgabcdefg12
 */
const AesEncrypt = (word, keyStr = 'HdBbAxyfM6vuU5wq') => {
  var key = CryptoJS.enc.Utf8.parse(keyStr)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

//AES解密
const AesDecrypt = (word, keyStr = 'HdBbAxyfM6vuU5wq') => {
  var key = CryptoJS.enc.Utf8.parse(keyStr)
  var decrypt = CryptoJS.AES.decrypt(word ? word : '', key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

/**
 * AES加密
 * 用生成的密钥加密  得到密文
 *
 * @param content 原文
 * @param keyStr 16位密钥
 */

const getAESEncryption = (content, keyStr) => {
  var encryption = AesEncrypt(content, keyStr)
  // debugger;
  return encryption
}

/**
 * AES解密
 * 根据返回的aeskey 解密  得到原文
 *
 * @param content 密文
 * @param aeskey  请求接口后返回的密钥
 */
const getAESDecryption = (content, aeskey) => {
  var decryption = AesDecrypt(content, aeskey)
  return decryption
}

//keys
//  RSA服务端公钥
const serverPubkey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClC2MafxQ8Gn1qbqYuCttUoSUMtcykcYi3IZYYDvK4MY7MtHtXzrvEcJDeXW9aSQtvoVEtLB1fQBj41ScHNF5oWwNy9anms86xx8ry1eP5uHAT+MrW9mVrLkftB9EktHblQwUgTs5dRhTXAF3v12SkmOV1UBr4AfFYb9lpsximbQIDAQAB`
//  RSA本地公钥
const localPubkey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDUmQHsRYhxMh4ULFgW2eereXv3vHxshaJ6+fvOARuYLubUbiezth2MD3YjanFSlKzmPsOzcXZ4UqL2b3HLNJZru5Yw58gHz4Z1S5i5duJt5m1UrYXUFYs61IfagK6DqQExfjrRtNbFPRb3h2GGpB1BbOf64XXvjBG1qG/43V0bRwIDAQAB'
//   RSA本地私钥
const localPrivatekey =
  'MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBANSZAexFiHEyHhQsWBbZ56t5e/e8fGyFonr5+84BG5gu5tRuJ7O2HYwPdiNqcVKUrOY+w7NxdnhSovZvccs0lmu7ljDnyAfPhnVLmLl24m3mbVSthdQVizrUh9qAroOpATF+OtG01sU9FveHYYakHUFs5/rhde+MEbWob/jdXRtHAgMBAAECgYEAn9/AdnGDvbw2qmz+gZC0i1r8QrzXxLRqD5jWJ4Dlw3fh1nZQHPEjHySxbsipF7T+oNcqTFNTCAD8093S8UFGq7XQbtSvbOtuUUudobwHDK8itL2HD9zUJceSTpYReHuiSd3N4PelRWvSdx0qj2sDutNxmGhH1Hf0LdGTezi79oECQQD6YmofDke9UDrsBEE0qIBf6pZIosDVL7xIIrQaFfch1L3JgRdxX32YtLcgnrg928CRprqoWuJZuXd6+b6qUYtxAkEA2V2jz0eRw5KkiVkvN5A2lrMX/FCQyjIM5ZJka3Uhefcrq3XFSdqR9SrdO25dAhzSSbTBA2T+se+pDFCdqQuGNwJAa5PpQJqkHCTijBFv6q4TKiLimybCb1ZpMR0oAKU7X1/Gg1NhvSZoEjpjDDLluj42yN24CSmzYxWazk2LrCYJIQJBAIv21/wowZuFWZ13aAgHPJ9dQxydZB5OjC9nTHJFQgEfP2dwtlEQBNwxdbNHJWyu0lnTolVlOvuortnXLy4i1ZECQQCL35zi7YWreQmydd/l+bTrUwNKc/sG+jRCaa/aFXCtWyaLnTJrOM57ahnMr2TK20T8B3yeep1vVIvc171PHc5u'

/**
 * RSA加密
 *
 * @param data 加密内容
 */

const $rsaEncrypt = () => {
  let jse = new JSEncrypt()
  // data = localPubkey
  // 加密用的是服务端公钥serverPubkey
  jse.setPublicKey(serverPubkey)
  return jse.encryptLong(localPubkey)
}

/**
 * RSA解密
 *
 * @param data 解密内容
 */

const $rsaDecrypt = (data) => {
  let jse = new JSEncrypt()
  jse.setPrivateKey(localPrivatekey)
  return jse.decryptLong(data)
}

/**
 * KEY字符串再次加密
 */
const compileStr = (code) => {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
  }
  return escape(c)
}
/**
 * KEY字符串进行解密
 * @param {Object} code
 */
const uncompileStr = (code) => {
  code = unescape(code)
  var c = String.fromCharCode(code.charCodeAt(0) - code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
  }
  return c
}
/**
 * 判断是不是json字符串
 * @param {String} str
 */
const isJSON = (str) => {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log('error：' + str + '!!!' + e)
      return false
    }
  }
}



export {
  AesEncrypt,
  AesDecrypt,
  getAESEncryption,
  getAESDecryption,
  $rsaEncrypt,
  $rsaDecrypt,
  isJSON,
  ReqIv
}
